export function validateAmount(amount: string): string {
  const numberRegex = '^-?[0-9]*[\\.,]?[0-9]*$';
  if (amount.search(numberRegex) === -1) {
    return 'invalid-characters';
  }

  if (amount.search('[,\\.]') !== -1 && amount.search('[,\\.][0-9]{0,2}$') === -1) {
    return 'too-many-decimal-places';
  }

  if (amount === '' || amountAsNumber(amount) === 0) {
    return 'not-empty';
  }

  if (amountAsNumber(amount) < 0) {
    return 'negative-number';
  }

  return '';
}

export function amountAsNumber(amount: string): number {
  return Number(amount.replace(',', '.'));
}
